module.exports = __webpack_public_path__ + "img/wishlist.a2ce3eed.svg";